/* istanbul ignore file */
import React from 'react';
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import InvoiceBreadcrumbs from 'domain/finance/invoice/shared/InvoiceBreadcrumbs';

const UpdateInvoiceBreadcrumbs = () => {
  return (
    <InvoiceBreadcrumbs>
      <UpdateBreadcrumbItem entity="Invoice" />
    </InvoiceBreadcrumbs>
  );
};

export default UpdateInvoiceBreadcrumbs;
